<app-expandable-section-box
  [title]="'Visibility'"
  [iconClass]="'icon-eye'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
>
  <div class="flex flex-col flex-1 py-3" expandedContent>
    <mat-checkbox
      class="hover:text-project-2100 hover:underline"
      color="primary"
      [formControl]="restrictToRegisteredUsersControl"
      data-testid="checkbox-list-item"
    >
      Restrict this article to registered users
    </mat-checkbox>
    <mat-checkbox
      class="hover:text-project-2100 hover:underline"
      color="primary"
      [formControl]="paywallPremiumContent"
      data-testid="checkbox-list-item"
    >
      Paywall Premium Content
    </mat-checkbox>
    <mat-checkbox
      class="hover:text-project-2100 hover:underline"
      color="primary"
      [formControl]="notForCompetitors"
      data-testid="checkbox-list-item"
    >
      Not for Competitors
    </mat-checkbox>
    <mat-checkbox
      class="hover:text-project-2100 hover:underline"
      color="primary"
      [formControl]="hideThisArticleControl"
      data-testid="checkbox-list-item"
    >
      Hide from all lists
    </mat-checkbox>
    <mat-checkbox
      class="hover:text-project-2100 hover:underline"
      color="primary"
      [formControl]="notForNewsFeedsControl"
      data-testid="checkbox-list-item"
    >
      Exclude from clients' feeds
    </mat-checkbox>

    <mat-checkbox
      class="hover:text-project-2100 hover:underline"
      color="primary"
      [formControl]="notForGoogleNewsSitemapsControl"
      data-testid="checkbox-list-item"
    >
      Exclude from Google News
    </mat-checkbox>
  </div>
  <div notExpandedContent class="p-4 text-xs empty:py-0 text-project-2400">
    <p *ngIf="restrictToRegisteredUsersControl.value">
      Restrict this article to registered users
    </p>
    <p *ngIf="paywallPremiumContent.value">Paywall Premium Content</p>
    <p *ngIf="notForCompetitors.value">Not for Competitors</p>
    <p *ngIf="hideThisArticleControl.value">Hide this article</p>
    <p *ngIf="notForNewsFeedsControl.value">Not for news feeds</p>
    <p *ngIf="notForGoogleNewsSitemapsControl.value">
      Not for Google news sitemaps
    </p>
  </div>
</app-expandable-section-box>
